/**
 * useAuth - Convenience hook for consuming AuthContext.
 *
 * Returns the full AuthContextValue object which includes:
 *	 - user, isAuthenticated, isLoading	 (auth state)
 *	 - login, loginWithO365, loginWithGoogle, logout  (auth actions)
 *	 - hasRole, hasAnyRole	(role-checking utilities)
 *
 * Throws an error if called outside of an <AuthProvider>, ensuring that
 * consumers get a clear message rather than undefined context values.
 *
 * Usage:
 *	 const { user, login, logout, hasRole } = useAuth();
 */
import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

export function useAuth() {
	const context = useContext(AuthContext);
	// Guard: ensure this hook is only used inside a component tree
	// wrapped by <AuthProvider>. Fail fast with a descriptive error.
	if (context === undefined) {
		throw new Error('useAuth must be used within an AuthProvider');
	}
	return context;
}
